<template>
  <CRow>
    <CCol :class="analysis != null ? 'col-md-9' : 'col-md-12'">
      <CCard>
        <CCardHeader>
          <circle-icon></circle-icon>
          병해영상분석
          <div
            style="position: absolute; top: -2px; right: 0"
            v-if="engine != null && engine.visible"
          >
            <CSelect
              placeholder="농장을 선택하세요"
              :value.sync="engine.model"
              :options="engine.versionList"
              class="m-2"
            />
          </div>
        </CCardHeader>
        <CCardBody>
          <CRow v-if="image.status === ''">
            <CCol md="12">
              <div
                class="disease-image-wrap dash"
                @dragover.prevent
                @dragenter.prevent
                @drop.prevent="onDrop"
                @click="$refs.diseaseImageFile.click()"
              >
                <div class="disease-image-help">
                  <div style="width: 60px">
                    <ImageIcon></ImageIcon>
                  </div>
                  <div>
                    <CButton color="light">파일 선택</CButton>
                  </div>
                  <div>또는 파일을 여기로 끌어놓으세요</div>
                </div>
                <input
                  ref="diseaseImageFile"
                  type="file"
                  accept="image/bmp,.bmp,image/jpeg,.jpg,.jpeg,image/png,.png"
                  @change="onChangeImageFile"
                />
              </div>
            </CCol>
          </CRow>
          <CRow
            v-else-if="image.status === 'ready'"
            v-viewer="{ inline: false, title: false }"
          >
            <CCol md="12">
              <div class="disease-image-wrap dash">
                <div class="disease-image-box right-top">
                  <CButton color="danger" @click="clearImage"
                    ><i class="fa fa-times" aria-hidden="true"></i
                  ></CButton>
                </div>
                <div class="disease-image-box right-bottom">
                  <CButton color="primary" @click="onAnalysisRequest"
                    >분석 요청
                  </CButton>
                </div>
                <div class="disease-image-preview">
                  <img
                    :src="app.getUrl(image.src)"
                    :class="image.clazz"
                    ref="image"
                  />
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow v-else v-viewer="{ inline: false, title: false }">
            <CCol
              col="12"
              :class="analysis.status === 'DISEASE' ? 'col-md-6' : 'col-md-12'"
            >
              <div class="disease-image-wrap dash mb-4 mb-md-0">
                <div
                  class="disease-image-box disease-image-label left-top bg-primary"
                >
                  원본
                </div>
                <div class="disease-image-box right-top">
                  <CButton color="danger" @click="clearImage"
                    ><i class="fa fa-times" aria-hidden="true"></i
                  ></CButton>
                </div>
                <div class="disease-image-preview">
                  <img
                    :src="app.getUrl(analysis.imageUrl)"
                    :class="image.clazz"
                  />
                </div>
              </div>
            </CCol>
            <CCol
              col="12"
              :class="analysis.status === 'DISEASE' ? 'col-md-6' : 'd-none'"
            >
              <div class="disease-image-wrap">
                <div
                  class="disease-image-box disease-image-label left-top bg-color-green-dark"
                >
                  진단
                </div>
                <div class="disease-image-preview">
                  <img
                    :src="app.getUrl(analysis.analysisImageUrl)"
                    :class="image.clazz"
                  />
                </div>
              </div>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>

    <CCol md="3" v-if="analysis != null">
      <CCard>
        <CCardHeader> 병해진단결과</CCardHeader>
        <CCardBody>
          <div v-if="analysis.status === 'UNKNOWN'">분석 결과가 없습니다.</div>
          <div
            v-else
            v-for="(analysisResult, index) in analysis.analysisResultList"
            :key="index"
          >
            <a :href="getAnalysisInfoUrl(analysisResult)" target="_blank">
              {{ index + 1 }}. {{ analysisResult.name
              }}{{
                analysisResult.numberOfDetections
                  ? "(" + analysisResult.numberOfDetections + ")"
                  : ""
              }}
            </a>
          </div>
        </CCardBody>
      </CCard>
    </CCol>

    <SearchAddressModal
      v-if="modal.searchAddress.visible"
      :properties="modal.searchAddress"
    >
    </SearchAddressModal>
  </CRow>
</template>

<script>
import core from "@/core";
import SearchAddressModal from "@/modals/core/SearchAddressModal";
import EXIF from "exif-js";
import CoreKakaoMap from "@/core/core-kakao-map";
import ImageIcon from "@/components/icons/ImageIcon";
import DiseaseService from "@/services/disease/disease.service";
import MixinStorage from "@/mixins/storage";
import store from "@/store";

export default {
  name: "DiseaseImageComponent",
  components: {
    SearchAddressModal,
    ImageIcon,
  },
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          cropCode: "",
          engine: {
            visible: false,
            versionList: [],
          },
        };
      },
    },
  },
  mixins: [MixinStorage("disease")],
  data() {
    return {
      app: store.state.app,
      engine: {
        visible: false,
        model: "v1",
        versionList: [],
      },
      image: {
        status: "",
        name: "",
        src: "",
        clazz: "",
        item: null,
      },
      analysis: null,
      modal: {
        searchAddress: {
          visible: false,
          params: {
            type: "add",
            item: null,
            loadMyLocation: false,
          },
          watchClose: {
            result: "",
            item: null,
          },
        },
      },
    };
  },
  mounted() {},
  watch: {
    "properties.cropCode"(cropCode) {
      this.clearImage();
      this.engine = core.utils.deepCopy(this.properties.engine);
      this.engine.model = "v1";
    },

    "modal.searchAddress.watchClose"() {
      const modal = this.modal.searchAddress;
      if (modal.watchClose.result === "confirm") {
        const item = modal.watchClose.item;
        //console.log("item : ", item);
        const image = this.image;
        image.item.latitude = item.latitude;
        image.item.longitude = item.longitude;
        image.item.address1 = item.address1;
        image.item.address2 = item.address2;
        if (image.item.address2 == null) {
          image.item.address2 = "";
        }
        this.onAnalysisRequest();
      }
    },
  },
  methods: {
    clearImage() {
      this.image.status = "";
      this.image.name = "";
      this.image.src = "";
      this.image.clazz = "";
      this.image.item = null;
      this.analysis = null;
    },
    onDrop(event) {
      this.inputImageFile(event.dataTransfer.files);
    },
    onChangeImageFile(e) {
      this.inputImageFile(e.target.files);
    },
    inputImageFile(files) {
      if (files.length) {
        let file = files[0];
        if (!/^image\//.test(file.type)) {
          alert("이미지 파일만 등록이 가능합니다");
          return false;
        }
        this.image.name = file.name;
        this.preview(file);
      } else {
        this.clearImage();
      }
    },
    async preview(file) {
      const image = this.image;
      core.loader.show("이미지 크기 변환중...");
      const item = (image.item = await core.utils.image.getImageBlob(
        file,
        1980,
      ));
      //console.log("image : ", image);
      if (item.width < item.height) {
        image.clazz = "vertical";
      } else {
        image.clazz = "";
      }
      image.src = item.dataUri;
      image.status = "ready";
      core.loader.hide();

      function convertGpsDmsToDegree(degrees, minutes, seconds, direction) {
        let dd = degrees + minutes / 60 + seconds / (60 * 60);

        if (direction === "S" || direction === "W") {
          dd = dd * -1;
        } // Don't do anything for N or E
        return dd;
      }

      EXIF.getData(file, function() {
        const allMetaData = EXIF.getAllTags(this);
        //console.log("allMetaData : ", allMetaData);
        const gpaLatitude = allMetaData.GPSLatitude;
        const gpaLongitude = allMetaData.GPSLongitude;
        if (gpaLatitude != null && gpaLongitude != null) {
          const latDegree =
            gpaLatitude[0].numerator / gpaLatitude[0].denominator;
          const latMinute =
            gpaLatitude[1].numerator / gpaLatitude[1].denominator;
          const latSecond =
            gpaLatitude[2].numerator / gpaLatitude[2].denominator;
          const latDirection = allMetaData.GPSLatitudeRef;
          item.latitude = Number(
            convertGpsDmsToDegree(
              latDegree,
              latMinute,
              latSecond,
              latDirection,
            ).toFixed(7),
          );

          const lngDegree =
            gpaLongitude[0].numerator / gpaLongitude[0].denominator;
          const lngMinute =
            gpaLongitude[1].numerator / gpaLongitude[1].denominator;
          const lngSecond =
            gpaLongitude[2].numerator / gpaLongitude[2].denominator;
          const lngDirection = allMetaData.GPSLongitudeRef;
          item.longitude = Number(
            convertGpsDmsToDegree(
              lngDegree,
              lngMinute,
              lngSecond,
              lngDirection,
            ).toFixed(7),
          );
        }
      });
    },
    async onAnalysisRequest() {
      const image = this.image;
      //console.log("image : ", image);
      if (image.item.latitude == null || image.item.longitude == null) {
        //console.log("위치 지정 필요");
        const result = await core.alert.show({
          title: "알림",
          body: "사진 촬영 위치를 선택해주세요",
          showCancelButton: true,
          confirmButtonText: "계속",
        });
        if (result === "confirm") {
          this.modal.searchAddress.params.loadMyLocation = true;
          this.modal.searchAddress.visible = true;
        }
        return;
      }
      core.loader.show("병해 영상 분석 중...");
      try {
        const formData = new FormData();
        formData.append("fileObj", image.item.blob, image.item.filename);
        formData.append("latitude", image.item.latitude);
        formData.append("longitude", image.item.longitude);
        if (image.item.address1 == null) {
          // 주소 가져오기
          const kakaoMap = new CoreKakaoMap();
          const result = await kakaoMap.findAddressByLatAndLng(
            image.item.latitude,
            image.item.longitude,
          );
          image.item.address1 = result.address;
          image.item.address2 = result.buildingName;
          if (image.item.address2 == null) image.item.address2 = "";
          //console.log("result : ", result);
        }
        formData.append("address1", image.item.address1);
        formData.append("address2", image.item.address2);
        formData.append("cropCode", this.properties.cropCode);
        if (this.engine.visible) {
          formData.append("engine", this.engine.model);
        }
        const analysis = await DiseaseService.imageAnalysis(formData);

        image.status = "result";
        this.analysis = analysis;
      } catch (e) {
        console.log(e);
      }

      core.loader.hide();
    },
    getAnalysisInfoUrl(analysisResult) {
      return DiseaseService.getInfoUrl(
        analysisResult.name,
        analysisResult.similarity,
      );
    },
  },
};
</script>
